module.exports = __webpack_public_path__ + "static/media/bpt.323ab46f.svg";